import StoredLayout from '../../layouts/StoredLayout'
import Sliders from './Sliders'
export default StoredLayout(Sliders)
